module.exports = __webpack_public_path__ + "assets/bbecdeb25daee4cce6b25510c4ce8c48.mp4";